import { SettingsBankSetupContainer } from 'src/containers';

export const SettingsBankSetup = () => <SettingsBankSetupContainer />;
